export const timeTypes = new Set([
    'timepicker', 
]);

export const dateTypes = new Set([
    'datepicker', 
    'NCTZDatePickerStart', 
    'NCTZDatePickerEnd', 
    'datetimepicker', 
    'rangepicker', 
    'datePickerNoTimeZone',
    'NCTZDatePickerRangeDay',
    'NCTZDatePickClientHourTime',
    'NCTZDatePickClientTime',
    'monthpicker',
    'yearpicker',
]);

export const selectTypes = new Set([
    'select',
    'radio',
    'checkbox',
]);

export const switchTypes = new Set([
    'switch',
    'checkbox_switch',
    'switch_browse',
]);

export const presetColumns = new Set([
    'INDEX',
    'CHECKBOX',
    'opr',
    'operate',
]);

// NC业务中特殊的Key
export const ROW_KEY = 'rowid';
export const COLUMN_KEY = 'attrcode';
export const IS_LEAF_KEY = 'isleaf';

export const ROW_STATUS = {
    ORIGIN: "0",
    EDIT: "1",
    ADD: "2",
    DELETE: "3",
};

export const ERROR_SCALE = new Set([undefined, null, '-1', -1]);

export const DEFAULT_COLOR = new Set(['#111111', '#555555', '#111', '#555']);